// @ts-nocheck

import React from 'react'
import PropTypes from 'prop-types'
import { Popconfirm } from '@lmc/ui-kit'

/**
@description Renders an Antd Popconfirm

https://ant.design/components/popconfirm/

N.B. getPopupContainer allows you to pass
styles down via a .less file. See TextField
for an example.

@param {node} children. What you click on to
see the popconfirm. E.g. FormInput.

@param {object} confirmProps. Object containing
settings for the Popconfirm

{
    confirmInputStyle: styles.prepopField,
    cancelButtonProps: {
        icon: <Icon
            name="CloseOutlined"
            style={styles.buttonIcon}
        />,
        size: 'large'
    },
    cancelText: 'No',
    okButtonProps: {
        icon: <Icon
            name="CheckOutlined"
            style={styles.buttonIcon}
        />,
        size: 'large'
    },
    okText: 'Yes, edit',
    title: <div style={{ marginBottom: 16 }}>
        <div style={styles.routeLabel}>Are you sure you want to edit?</div>
        <div style={styles.text}>This information is taken from the NHS dm+d database. </div>
    </div>
}

@param {bool} disabled. Popconfirm will not display if true.

@param {func} onConfirm. Function that fires when ok button
is clicked

@param {string} placement. Defines where in the
target element the Popconfirm will render.

@returns {function} AntdPopconfirm.
*/

export default function AntdPopconfirm(props) {
  const {
    children,
    confirmProps,
    disabled,
    onConfirm,
    placement = 'topLeft',
  } = props

  return (
    <Popconfirm
      {...confirmProps}
      disabled={disabled}
      icon={null}
      getPopupContainer={(triggerNode) => triggerNode}
      onConfirm={onConfirm}
      placement={placement}
    >
      {children}
    </Popconfirm>
  )
}

AntdPopconfirm.propTypes = {
  children: PropTypes.node,
  confirmProps: PropTypes.object,
  disabled: PropTypes.bool,
  onConfirm: PropTypes.func,
  placement: PropTypes.string,
}
